import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { KidCarousel } from '@kid-ui/krn';
import assetsMap from './uri.json';
import { onShowGuaranteeV1 } from '@/page/detail/views/jump';
import { lang } from '@/common/const';
import { scaleW } from '@/common/style';
import { ViewVisible } from '@/component/ViewVisible/ViewVisible';
import { logger } from '@/common/log';
import { afterPv } from '@/common/utils/afterPv';
import { useFirstScreenAB } from '../abTest/firstScreen/useFirstScreenAb';
import { KImage } from '@/component/RtlLayout';

type CarouselConfig = {
    carouselHeight?: number;
    // 轮播高度
    carouselWidth?: number;
    // 轮播宽度
    loop?: boolean;
    // 是否循环轮播
    autoplay?: boolean;
    // 是否自动播放
    autoplayTimeout?: number;
    // 设置自动播放时间
    horizontal?: boolean;
    // 设置 carousel 为水平模式，值为 false 时竖直模式
    showsPagination?: boolean;
    // 是否展示指示器
    borderRadius?: number;
    // 设置 carousel 的圆角
    itemId?: number;
    // onShowGuaranteeV1需传入
    openMask?: boolean;
    // 是否跳转到服务保障详细页
    index?: number;
};

const carouselBaseConfig: CarouselConfig = {
    carouselHeight: scaleW(36),
    carouselWidth: scaleW(414),
    loop: true,
    autoplay: true,
    autoplayTimeout: 2,
    horizontal: false,
    showsPagination: false,
    borderRadius: 0,
    openMask: false,
    itemId: 0,
};

const carouselLangType = (type: String) => (lang === 'pt-BR' ? type + '_PORTUGUESE' : type + '_ENGLISH');
const carouselType = (key: number, type: String) => (key === 1 ? type + '_ONE' : type + '_TWO');
const lineMap = {
    DETAIL: 'link',
    LIVE: 'link',
    ORDER: 'link',
};
const baseKey = ['ORDER', 'NEW'];

const useShowGuarantee = ({ type = 'DETAIl', carouselConfig = {}, style = {} }: { type?: any; carouselConfig?: CarouselConfig; style?: any }) => {
    const isBaseKey = baseKey.some((item) => item === type);

    const state = useFirstScreenAB();

    const guaranteeStatus = {
        ifServiceGuarantee: state.ifServiceGuarantee,
        serviceGuaranteeStyle: state.serviceGuaranteeStyle,
        guaranteeAssets: isBaseKey
            ? assetsMap[carouselLangType(type)]
            : assetsMap[carouselType(state.serviceGuaranteeStyle, carouselLangType(type))] || [],
        status: lineMap?.[type] ? state.link_service_guarantee || false : state.ifServiceGuarantee,
    };

    //type为需展示轮播的页面，例如'DETAIL', 'LIVE' style为轮播图样式
    const GuaranteeSwiper = () => {
        // 合并传入
        const mergeConfig = { ...carouselBaseConfig, ...carouselConfig };

        const onPressAble = () => {
            if (mergeConfig.openMask) {
                onShowGuaranteeV1(0);
                afterPv.then(() =>
                    logger.sendClick({ action: 'REST_ASSURED_PURCHASE_BAR', params: { type: guaranteeStatus.serviceGuaranteeStyle === 1 ? 1 : 0 } }),
                );
            }
        };

        return (
            <View>
                {!state.isAbLoading ? (
                    <TouchableOpacity activeOpacity={1} onPress={onPressAble}>
                        <ViewVisible
                            onVisible={() => {
                                afterPv.then(() =>
                                    logger.sendShow({
                                        action: 'REST_ASSURED_PURCHASE_BAR',
                                        params: { type: guaranteeStatus.serviceGuaranteeStyle === 1 ? 1 : 0 },
                                    }),
                                );
                            }}
                        >
                            <KidCarousel {...mergeConfig}>
                                {guaranteeStatus.guaranteeAssets.map((imgUri) => {
                                    return (
                                        <KImage
                                            source={{ uri: imgUri }}
                                            resizeMode="cover"
                                            style={[{ width: scaleW(414), height: scaleW(36) }, style]}
                                        />
                                    );
                                })}
                            </KidCarousel>
                        </ViewVisible>
                    </TouchableOpacity>
                ) : null}
            </View>
        );
    };

    return {
        GuaranteeSwiper,
        guaranteeStatus: guaranteeStatus.status,
        guaranteeStyle: guaranteeStatus.serviceGuaranteeStyle,
    };
};

export default useShowGuarantee;
